var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "el-form",
                { attrs: { inline: "", size: "small", "label-width": "80px" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "对账单号:" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: { placeholder: "请输入", clearable: "" },
                        model: {
                          value: _vm.listPram.billNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.listPram, "billNo", $$v)
                          },
                          expression: "listPram.billNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单号:" } },
                    [
                      _c("el-input", {
                        staticClass: "selWidth",
                        attrs: { placeholder: "请输入", clearable: "" },
                        model: {
                          value: _vm.listPram.orderNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.listPram, "orderNo", $$v)
                          },
                          expression: "listPram.orderNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商家类型:" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: { placeholder: "请选择", clearable: "" },
                          model: {
                            value: _vm.listPram.merchantType,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "merchantType", $$v)
                            },
                            expression: "listPram.merchantType",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "获得供应商", value: "1" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "选择商家:" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            placeholder: "请选择",
                            clearable: "",
                            filterable: "",
                          },
                          model: {
                            value: _vm.listPram.merchantId,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "merchantId", $$v)
                            },
                            expression: "listPram.merchantId",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "家家乐", value: "1" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "是否有损失:" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: { placeholder: "请选择", clearable: "" },
                          model: {
                            value: _vm.listPram.hasLoss,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "hasLoss", $$v)
                            },
                            expression: "listPram.hasLoss",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "是", value: "1" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "否", value: "0" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "创建人:" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: { placeholder: "请选择", clearable: "" },
                          model: {
                            value: _vm.listPram.creator,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "creator", $$v)
                            },
                            expression: "listPram.creator",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "张三", value: "1" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "对账状态:" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: { placeholder: "请选择", clearable: "" },
                          model: {
                            value: _vm.listPram.reconciliationStatus,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.listPram,
                                "reconciliationStatus",
                                $$v
                              )
                            },
                            expression: "listPram.reconciliationStatus",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "已核对", value: "1" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "未核对", value: "0" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "打款状态:" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: { placeholder: "请选择", clearable: "" },
                          model: {
                            value: _vm.listPram.paymentStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "paymentStatus", $$v)
                            },
                            expression: "listPram.paymentStatus",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "已打款", value: "1" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "部分打款", value: "2" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "未打款", value: "0" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "btn-group" },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary", size: "small" } },
                    [_vm._v("生成对账单")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: { click: _vm.openPendingDialog },
                    },
                    [_vm._v("待对账记录")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.listData.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
                border: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", "min-width": "40" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "billNo",
                  label: "对账单号",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "merchantName",
                  label: "商家名称",
                  "min-width": "70",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "merchantType",
                  label: "商家类型",
                  "min-width": "90",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "账单周期", "min-width": "140" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [_vm._v(_vm._s(scope.row.periodStart))]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v("至 " + _vm._s(scope.row.periodEnd)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "generateTime",
                  label: "生成时间",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderCount",
                  label: "订单数量",
                  "min-width": "70",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "订单金额", "min-width": "70" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          ¥" +
                            _vm._s(scope.row.orderAmount) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "成交结算金额", "min-width": "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          ¥" +
                            _vm._s(scope.row.settledAmount) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "实际结算金额", "min-width": "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          ¥" +
                            _vm._s(scope.row.actualAmount) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "打款金额", "min-width": "70" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          ¥" +
                            _vm._s(scope.row.paymentAmount) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "状态", "min-width": "70" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          { class: _vm.statusClass(scope.row.status) },
                          [_vm._v(_vm._s(_vm.STATUS_MAP[scope.row.status]))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "对账状态", "min-width": "70" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.RECONCILIATION_STATUS_MAP[
                                scope.row.reconciliationStatus
                              ]
                            )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "打款状态", "min-width": "70" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            class: _vm.paymentStatusClass(
                              scope.row.paymentStatus
                            ),
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.PAYMENT_STATUS_MAP[scope.row.paymentStatus]
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "creatorName",
                  label: "创建人",
                  "min-width": "60",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "reconciliationRemark",
                  label: "对账备注",
                  "min-width": "70",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "financeRemark",
                  label: "财务备注",
                  "min-width": "70",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", "min-width": "160", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "operation-group" },
                          [
                            scope.row.status === 2
                              ? [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openDownloadBillDialog(
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("下载账单明细")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openBillDetailDialog(
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("详情")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openBillItemsDialog(
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("账单明细")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openCollectionDetailDialog(
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("收款详情")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    { attrs: { type: "text", size: "small" } },
                                    [_vm._v("确认对账单")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "text-danger",
                                      attrs: { type: "text", size: "small" },
                                    },
                                    [_vm._v("删除")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openRemarkDialog(
                                            scope.row,
                                            "reconciliation"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("对账备注")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openRemarkDialog(
                                            scope.row,
                                            "finance"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("财务备注")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openPaymentDetailsDialog(
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("打款明细")]
                                  ),
                                ]
                              : scope.row.status === 0
                              ? [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "text-warning",
                                      attrs: { type: "text", size: "small" },
                                    },
                                    [_vm._v("重新生成")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-button",
                                    { attrs: { type: "text", size: "small" } },
                                    [_vm._v("打款明细")]
                                  ),
                                ]
                              : [
                                  _c("span", { staticClass: "text-muted" }, [
                                    _vm._v("--"),
                                  ]),
                                ],
                          ],
                          2
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.listPram.page,
              "page-sizes": _vm.constants.page.limit,
              layout: _vm.constants.page.layout,
              total: _vm.listData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("PendingReconciliationDialog", { ref: "pendingDialogRef" }),
      _vm._v(" "),
      _c("DownloadBillDialog", { ref: "downloadBillDialogRef" }),
      _vm._v(" "),
      _c("BillDetailDialog", { ref: "billDetailDialogRef" }),
      _vm._v(" "),
      _c("BillItemsDialog", { ref: "billItemsDialogRef" }),
      _vm._v(" "),
      _c("RemarkDialog", { ref: "remarkDialogRef" }),
      _vm._v(" "),
      _c("CollectionDetailDialog", { ref: "collectionDetailDialogRef" }),
      _vm._v(" "),
      _c("PaymentDetails", { ref: "paymentDetailsRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }